import React from 'react';
import { useIntl, defineMessage } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../primitives/Panel';
/* eslint-disable css-modules/no-unused-class */
import styles from './TrendsSummaryPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

const messages = {
  kicker: defineMessage({
    id: 'app.sml.aiInsights.kicker.pending',
    defaultMessage: 'Writing today’s brief…',
  }),
};

const SummaryPendingViewComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <Panel className={styles.panel}>
      <PanelHead title={intl.formatMessage(messages.kicker)} />
      <PanelBody>
        <div className={styles.skeletonLine} style={{ width: '60%' }} />
        <div className={styles.skeletonLine} style={{ width: '95%' }} />
        <div className={styles.skeletonLine} style={{ width: '80%' }} />
      </PanelBody>
    </Panel>
  );
};

export const SummaryPendingView = TypedMemo(SummaryPendingViewComponent);
